export const PHONE_NUMBER = "+57 3185527969";
export const LINKEDIN_USER = "linafernandaorozco";
export const LINKEDIN_LINK = "https://www.linkedin.com/in/linafernandaorozco";

export const EMAIL = "linaorozcoj@gmail.com";
export const EMAIL_SUBJECT = "Interés en Consultoría Legal";
